import { useEffect, useRef, useState } from 'react';

import i18n from "i18next";

import { useTranslation, Trans } from "react-i18next";
import Marquee from "react-fast-marquee";
import Fade from 'react-reveal/Fade';

import m1 from '../../img/Home/m1.webp';
import m3 from '../../img/Home/m2.webp';
import m2 from '../../img/Home/m3.webp';

import m1m from '../../img/Home/m1m.webp';
import m2m from '../../img/Home/m2m.webp';
import m3m from '../../img/Home/m3m.webp';

import mobm1 from '../../img/Home/MainBlockMobile/m1.webp';
import mobm2 from '../../img/Home/MainBlockMobile/m2.webp';
import mobm3 from '../../img/Home/MainBlockMobile/m3.webp';

import { Link } from "react-router-dom"

import './animate.css'

const images = [m1, m2, m3];

const mobimages = [mobm1, mobm2, mobm3];

const data = [
  {
    title: "30%",
    text: "home.6",
  },
  {
    title: "50%",
    text: "home.7",
  },
  {
    title: "75%",
    text: "home.8",
  },
]

function Main () {

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
      };

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    const { t } = useTranslation();

    const currentImages = isMobile ? mobimages : images;

    const [currentIndex, setCurrentIndex] = useState(0);
    const [nextIndex, setNextIndex] = useState(null);
    const [isAnimating, setIsAnimating] = useState(false);
    const maskRef = useRef(null);
    const intervalRef = useRef(null);

    const startAnimationToIndex = (newIndex) => {
      if (isAnimating || newIndex === currentIndex) return;
      setNextIndex(newIndex);
      setIsAnimating(true);
    };

    const handleNext = () => {
      const newIndex = (currentIndex + 1) % currentImages.length;
      startAnimationToIndex(newIndex);
      resetAutoSlide();
    };

    const handlePrev = () => {
      const newIndex = (currentIndex - 1 + currentImages.length) % currentImages.length;
      startAnimationToIndex(newIndex);
      resetAutoSlide();
    };

    const resetAutoSlide = () => {
      clearInterval(intervalRef.current);
      intervalRef.current = setInterval(() => {
        const next = (currentIndex + 1) % currentImages.length;
        startAnimationToIndex(next);
      }, 5000);
    };

    useEffect(() => {
      resetAutoSlide();
      return () => clearInterval(intervalRef.current);
    }, [currentIndex]);

    useEffect(() => {
      if (isAnimating && maskRef.current) {
        requestAnimationFrame(() => {
          maskRef.current.classList.add('active');
        });
      }
    }, [isAnimating]);

    const handleTransitionEnd = () => {
      setCurrentIndex(nextIndex);
      setNextIndex(null);
      setIsAnimating(false);
    };
    
      
    return(
        <div className="overflow-hidden relative max-w-[1920px] xl:h-screen mx-auto">
          <div>
            <img src={currentImages[currentIndex]} className="bg-image" alt="" />
            {nextIndex !== null && (
              <img
                src={currentImages[nextIndex]}
                alt=""
                className={`bg-image reveal-mask`}
                ref={maskRef}
                onTransitionEnd={handleTransitionEnd}
              />
            )}
            <div className="bg-[#000000B2] absolute w-full h-screen"></div>
          </div>
          
          <div className="max-w-[1220px] mx-auto relative mt-[70px] short-p:mt-[50px] md:mt-[100px] z-50">
              <div className="flex flex-col xl:flex-row items-center justify-between">
                  <Fade left><p className="text-[#F26522] text-[65px] md:text-[105px] xl:text-[150px] open-sans">{t('home.1')}</p></Fade>
                  <div className="h-[100px] w-px bg-[#F6F6F6] hidden xl:block"></div>
                  <Fade right><p className="open-sans text-[#F26522] text-[18px] md:text-[24px] xl:text-[30px] xl:max-w-[284.133px] mt-[12px] xl:mt-0"><Trans>{t('home.2')}</Trans></p></Fade>                 
                  <p className='text-[14px] xl:hidden block text-white text-center mt-[12px] open-sans'><Trans>{t('home.add')}</Trans>  </p>
                  <div className='short-pp:pb-[60px]'><Link to="/form"><div className='buttonmain short:mt-[30px] mt-[40px] xl:mt-[50px] block xl:hidden'>
                    <p className='montserrat text-[#1D1D1D] font-[600] text-[14px] md:text-[16px]'>{t('home.5')}</p>
                  </div></Link></div>
              </div>
              <div className="flex justify-between mx-[20px] md:mx-[40px] xl:mx-0 gap-0 xl:gap-[50px]">
                  <div className='hidden xl:block'>
                    <Fade left delay={500}><p className="max-w-[450px] open-sans text-[#F6F6F6] font-[300] text-[14px] xl:text-[16px] short:mt-[20px] mt-[80px]">{t('home.3')}</p></Fade>
                    <Fade left delay={700}><p className="max-w-[450px] open-sans text-[#F6F6F6] font-[300] text-[14px] xl:text-[16px] mt-[15px]">{t('home.4')}</p></Fade>
                    <Fade left delay={900}>
                    <div><Link to="/form"><div className='buttonmain mt-[50px] hover:scale-[1.1] transition-all'>
                        <p className='montserrat text-[#1D1D1D] font-[600] text-[14px] md:text-[16px]'>{t('home.5')}</p>
                      </div></Link></div>
                    </Fade>
                  </div> 
                  <div className="w-full xl:w-[650px] short-pp:hidden pb-[60px] short-p:mt-[20px] mt-[-90px] sm:mt-[10px] xl:mt-[30px] flex flex-col gap-y-[35px] mx-auto">
                      <div>
                        <div className="flex justify-between gap-[8px] md:gap-[38px] xl:gap-0 items-end w-full short-p:h-[160px] short:h-[180px] h-[300px]">
                          {[m1m, m2m, m3m].map((img, index) => {

                            const isActive = currentIndex === index;

                            return (
                              <div
                                key={index}
                                onClick={() => startAnimationToIndex(index)}
                                className={`relative overflow-hidden w-full transition-all duration-500 ease-in-out cursor-pointer ${
                                  currentIndex === index ? 'h-[190px] short-p:h-[160px] short:h-[200px] md:h-[300px] xl:w-[192px] ' : 'w-[calc(100%-52%)] short-p:h-[130px] short:h-[150px] sm:w-[calc(100%-20%)] h-[120px] md:h-[250px] xl:w-[192px]'
                                }`}
                              >
                                <img
                                  src={img}
                                  alt=""
                                  className="absolute bottom-0 w-full h-auto min-h-full object-cover"
                                />
                                <div className="bglinmain w-full h-full absolute top-0 left-0"></div>
                                <div
                                  className={`
                                    absolute bottom-[12px] left-[12px] xl:left-[18px] transition-opacity duration-300
                                    ${!isActive ? 'opacity-0 pointer-events-none xl:opacity-100 xl:pointer-events-auto' : ''}
                                  `}
                                >
                                  <p className="text-[18px] xl:text-[30px] text-[#F26522] relative">
                                    {data[index].title}
                                  </p>
                                  <p className="open-sans text-[#F6F6F6] font-[300] text-[14px] xl:text-[16px]">
                                    <Trans>{data[index].text}</Trans>
                                  </p>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      <div className="flex flex-row-reverse gap-[20px] items-end mt-[-20px]">
                          <div className={`flex gap-[15px] ${i18n.language === 'ar' ? 'flex-row-reverse' : ''}`}>
                              <div onClick={handlePrev} className="w-[38px] xl:w-[50px] h-[38px] xl:h-[50px] hover:scale-[1.1] transition-all rounded-full border border-[#F6F6F6] flex items-center justify-center cursor-pointer">
                                  <svg className='w-[18px] xl:w-[24px] h-[18px] xl:h-[24px]' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                      <path d="M21 12L3 12" stroke="#F6F6F6" stroke-linecap="round" stroke-linejoin="round"/>
                                      <path d="M6 15L3 12L6 9" stroke="#F6F6F6" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                              </div>
                              <div onClick={handleNext} className="w-[38px] xl:w-[50px] h-[38px] xl:h-[50px] hover:scale-[1.1] rotate-180 transition-all rounded-full border border-[#F6F6F6] flex items-center justify-center cursor-pointer">
                                  <svg className='w-[18px] xl:w-[24px] h-[18px] xl:h-[24px]' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                      <path d="M21 12L3 12" stroke="#F6F6F6" stroke-linecap="round" stroke-linejoin="round"/>
                                      <path d="M6 15L3 12L6 9" stroke="#F6F6F6" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                              </div>
                          </div>
                          <div className="h-[1.5px] bg-[#F26522] w-full"></div>
                          <Fade key={currentIndex}><p className="open-sans text-[#F26522] text-[23px] xl:text-[30px]">0{currentIndex+1}</p></Fade>
                      </div>
                  </div>
              </div>
          </div>
          <div className="bg-[#F26522] h-[50px] xl:h-[80px] w-full absolute bottom-0 flex items-center">
              <Marquee pauseOnHover={true} autoFill>
                  <p className="text-[#262626] open-sans leading-[1.4] text-[16px] xl:text-[28px]">{t('home.9')}</p>
              </Marquee>
          </div>
        </div>
    );
}

export default Main;